export enum AccessRequestState {
    Pending = 0,
    Approved = 1,
    Rejected = 2
}